<template>
  <div>
    <h3 class="modal-title"> PAYROLL AREA SETUP </h3>

    <b-form-group :class="{'error-input' : $v.data_setup.title.$error}">
      <label> Payroll Area Setup Title </label>
      <j-input
        v-model="$v.data_setup.title.$model"
        :max-length="255"
        placeholder="Title"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeForm">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveForm">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_setup: {
      title: {
        required,
      },
    },
  },
  data() {
    return {
      data_setup: {
        title: '',
      },
    };
  },
  computed: {
    generateData() {
      const data = {
        value_id: '0',
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_setup.title,
        component_master_id: this.dataMaster.id,
        info: '',
      };
      return data;
    },

    generateDataUpdate() {
      const data = {
        value_id: '0',
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_setup.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        info: '',
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_setup.title = this.dataEdit.name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent']),

    saveForm() {
      this.$v.data_setup.$touch();
      if (!this.$v.data_setup.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateData,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.closeForm();
      }
    },

    closeForm() {
      this.$emit('close-field');
      this.data_setup.title = '';
      setTimeout(() => {
        this.$v.data_setup.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/core/jPayrollAreaSetup.vue